import React from 'react'
import FileUpload from 'legacy/libs/components/file-upload'
import createReactClass from 'create-react-class'
import { GetText } from 'lib/gettext'

import s from './styles/gis-region.module.scss'

export default createReactClass({
  displayName: 'MapFileUpload',

  render() {
    return (
      <div className={s.upload__file}>
        <div className={s.instructions}>
          <GetText>
            Use file type that is associated with Google Maps, ArcGIS, and
            similar suites (.kml, .shp)
          </GetText>
        </div>
        <FileUpload
          accepts=".prj,.shp,.kml,.shx,.dbf,.sbn,.sbx"
          {...this.props}
        />
      </div>
    )
  },
})
